import { Component } from '@angular/core';
import { TipoAlertaEnum } from '@modules/gestao-alertas/models/alerta';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-custom-alerta',
  templateUrl: './custom-alerta.component.html',
  styleUrls: ['./custom-alerta.component.scss']
})


export class CustomAlertaComponent {

  tipoAlertaEnum = TipoAlertaEnum;
  alerta: any;

  constructor(private activeModal: NgbActiveModal) { }

  getStyleClass() {
    switch (this.alerta?.alertType) {
      case this.tipoAlertaEnum.Alerta:
        return 'alerta-alerta'
        break;
      case this.tipoAlertaEnum.Informacao:
        return 'alerta-informacao'
        break;
      case this.tipoAlertaEnum.Sucesso:
        return 'alerta-sucesso'
        break;
      case this.tipoAlertaEnum.Erro:
        return 'alerta-erro'
        break;
    }
  }

  getIconClass() {
    switch (this.alerta?.alertType) {
      case this.tipoAlertaEnum.Alerta:
        return 'uil uil-exclamation-triangle yellow'
      case this.tipoAlertaEnum.Informacao:
        return 'uil uil-info-circle blue'
      case this.tipoAlertaEnum.Sucesso:
        return 'uil uil-check-circle green'
      case this.tipoAlertaEnum.Erro:
        return 'uil uil-times-circle red'
    }
  }

  getStyleButton(){
    switch (this.alerta?.alertType) {
      case this.tipoAlertaEnum.Alerta:
        return {'background-color': '#FFC100'};
      case this.tipoAlertaEnum.Informacao:
        return {'background-color': '#00b9f2'};
      case this.tipoAlertaEnum.Sucesso:
        return {'background-color': '#00a956'};
      case this.tipoAlertaEnum.Erro:
        return {'background-color': '#ea3314'};
    }
  }

  fechar(): void {
    this.activeModal.close();
  }

}
